import { render, staticRenderFns } from "./InfoZona.vue?vue&type=template&id=f0cf7bda&"
import script from "./InfoZona.vue?vue&type=script&lang=js&"
export * from "./InfoZona.vue?vue&type=script&lang=js&"
import style0 from "./InfoZona.vue?vue&type=style&index=0&id=f0cf7bda&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports